import config from '../configs';

const initialState = {
  config,
};

const emailOptInSuccessModal = (state = initialState) => state;

export default emailOptInSuccessModal;
